import React, {useEffect, useRef, useState} from 'react'
import '@sendbird/uikit-react/dist/index.css';
import {View, StyleSheet, Text, Image, Pressable} from 'react-native-web';
import SendbirdChat from "@sendbird/chat";
import {
    GroupChannelFilter, GroupChannelListOrder,
    GroupChannelModule
} from "@sendbird/chat/groupChannel";
import {
    getActiveBusinessCreatorCampaigns,
    getActiveBusinessCreators,
    getBusinessSummary
} from "../services/BusinessService";
import plusIcon from "../icons/grey-plus-btn.png";
import Modal from "react-modal";
import SendbirdProvider from '@sendbird/uikit-react/SendbirdProvider';
import { GroupChannel } from '@sendbird/uikit-react/GroupChannel';
import Header from "./Header";
import {enableCreatorMessaging} from "../services/CreatorService";
import Select from "react-dropdown-select";
import blueLandscapeIcon from "../icons/blue-landscape-icon.png";
import defaultProfileIcon from "../icons/default-profile-icon.png";
import {useSearchParams} from "react-router-dom";

const Message = () => {

    const [businessSummary, setBusinessSummary] = useState({})
    const [selectedUser, setSelectedUser] = useState({})
    const [activeCreators, setActiveCreators] = useState([])
    const [activeCampaigns, setActiveCampaigns] = useState([])
    const [defaultCampaign, setDefaultCampaign] = useState({})
    const [channels, setChannels] = useState([])
    const [campaignFilter, setCampaignFilter] = useState({})
    const [newMessageModal, setNewMessageModal] = useState(false)
    const [showCampaignFilter, setShowCampaignFilter] = useState(false)
    const ref = useRef(null);
    const [searchParams] = useSearchParams();

    const sb = SendbirdChat.init({
        appId: '960C8598-DEDE-43E0-89FA-45442999623C',
        modules: [
            new GroupChannelModule(),
        ],
    });

    const myColorSet = {
        '--sendbird-light-primary-500': '#396DE0',
        '--sendbird-light-primary-400': '#396DE0',
        '--sendbird-light-primary-300': '#396DE0',
        '--sendbird-light-primary-200': '#396DE0',
        '--sendbird-light-primary-100': '#396DE0',
    };

    function afterOpenModal() {

    }

    function closeModal() {
        setNewMessageModal(false);
    }

    function openChatModal() {
        if (activeCampaigns.length > 0) {
            filterActiveCreators([activeCampaigns[0]]);
            setDefaultCampaign(activeCampaigns[0]);
        }
        setNewMessageModal(true);
    }

    function filterActiveCreators(selects) {
        let campaignId = null;
        if (selects.length > 0 && selects[0] && selects[0].value) {
            campaignId = selects[0].value;
        }
        getActiveBusinessCreators(campaignId)
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    if (campaignId != null) {
                        const params = {
                            customTypesFilter: [campaignId],
                            includeEmpty: true,
                        };
                        const query = sb.groupChannel.createMyGroupChannelListQuery(params);

                        if (query.hasNext) {
                            let channelMap = {};
                            let creators = {};
                            query.next()
                                .then(channels => {
                                    channels.forEach(channel => {
                                        const channelUrlParams = channel._url.split("_");
                                        channelMap[channelUrlParams[1]] = channel;
                                    })
                                    creators = resp.data.map(creator => ({
                                        ...creator,
                                        messaged: channelMap.hasOwnProperty(creator.id)
                                    }))
                                })
                                .finally(() => {
                                    setActiveCreators(creators);
                                })
                        } else {
                            setActiveCreators(resp.data);
                        }
                    }
                }
            })
    }

    function createNewMessage(user) {
        if (user.messaged) {
            loadUsers(businessSummary.businessId, defaultCampaign.value + "_" + user.id, null);
            setNewMessageModal(false);
        } else {
            enableCreatorMessaging(user.id)
                .then(resp => {
                    const params = {
                        invitedUserIds: [user.id],
                        name: user.first_name + " " + user.last_name + " and " + defaultCampaign.label,
                        operatorUserIds: [businessSummary.businessId],
                        channelUrl: defaultCampaign.value + "_" + user.id,
                        isDistinct: false,
                        customType: defaultCampaign.value,
                    };
                    sb.groupChannel.createChannel(params)
                        .then(sbResp => {
                            loadUsers(businessSummary.businessId, defaultCampaign.value + "_" + user.id, null);
                            setNewMessageModal(false);
                        })
                        .catch(err => {
                            console.log(err);
                        })
                })
        }
    }

    function openChat(user) {
        console.log(user);
        setSelectedUser(user);
    }

    function loadUsers(businessId, channelUrl, campaignId) {
        const groupChannelFilter = new GroupChannelFilter();
        groupChannelFilter.includeEmpty = true; // Optional.
        if (campaignId != null) {
            groupChannelFilter.customTypesFilter = [campaignId];
        }
        // groupChannelFilter.publicChannelFilter  = PublicChannelFilter.PUBLIC; // Retrieve public group channels. Optional.
        // groupChannelFilter.superChannelFilter = SuperChannelFilter.SUPER; // Retrieve Supergroup channels. Optional.

        const groupChannelCollection = sb.groupChannel.createGroupChannelCollection({
            filter: groupChannelFilter,
            order: GroupChannelListOrder.LATEST_LAST_MESSAGE,
            // ...
        });
        if (groupChannelCollection.hasMore) {
            groupChannelCollection.loadMore()
                .then(channelResp => {
                    let channelsArr = [];
                    channelResp.forEach((channel) => {
                        let newChannel = {};
                        if (channel.members && channel.members.length > 1) {
                            channel.members.forEach((member) => {
                                if (member.userId !== businessId) {
                                    newChannel.id = member.userId;
                                    newChannel.nickname = member.nickname;
                                }
                            })
                            newChannel.channel = channel;
                            if (newChannel.channel && newChannel.channel._url && newChannel.channel._url === channelUrl) {
                                openChat(newChannel);
                            }
                            channelsArr.push(newChannel);
                        }
                    });
                    setChannels(channelsArr);
                })
        }
    }

    function filterByCampaign(campaign) {
        loadUsers(businessSummary.businessId, null, campaign.value);
        setCampaignFilter(campaign);
        setShowCampaignFilter(false);
    }

    useEffect(()=>{
        getBusinessSummary()
            .then(resp => {
                if (resp.status === 200 && resp.data && resp.data.businessId) {
                    setBusinessSummary(resp.data);
                    try {
                        sb.connect(resp.data.businessId)
                            .then(() => {
                                loadUsers(resp.data.businessId, searchParams.get("channel"), null);
                                const params = {
                                    nickname: resp.data.name,
                                };
                                sb.updateCurrentUserInfo(params);
                            })
                            .catch(err => {
                                console.log(err);
                            })

                    } catch (err) {
                        // Handle error.
                    }
                }
            })
        getActiveBusinessCreatorCampaigns()
            .then(resp => {
                if (resp.status === 200 && resp.data) {
                    const dropDownOptions = resp.data.map((campaign) => ({
                        label: campaign.name,
                        value: campaign.id,
                        imageExists: campaign.imageExists,
                    }));
                    setActiveCampaigns(dropDownOptions);
                }
            })
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setShowCampaignFilter(false);
            }
        };
        document.addEventListener('click', handleClickOutside, true);
        return () => {
            document.removeEventListener('click', handleClickOutside, true);
        };
    }, []);

    return(
        <View style={styles.messageContainer}>
            <Header title="Messages" />
            <View style={styles.contentContainer}>
                <View style={styles.chatUsersContainer}>
                    <View style={styles.messagesHeader}>
                        <View>
                            <Pressable onPress={() => {setShowCampaignFilter(true)}}>
                                <Image
                                    source={blueLandscapeIcon}
                                    style={styles.addCampaignImg}
                                />
                            </Pressable>
                            {showCampaignFilter && (
                                <View style={styles.campaignFilterView} ref={ref}>
                                    <View style={styles.centeredView}>
                                        <Pressable 
                                            onPress={() => {filterByCampaign({})}}
                                            style={({ hovered }) => [
                                                styles.clearFilterButton,
                                                hovered && styles.clearFilterButtonHovered
                                            ]}
                                            accessible={true}
                                            aria-label="Clear campaign filter"
                                            role="button"
                                        >
                                            <Text style={styles.clearFilterText}>Clear Filter</Text>
                                        </Pressable>
                                    </View>
                                    {activeCampaigns.map((campaign) => (
                                        <Pressable 
                                            key={campaign.value} 
                                            style={({ hovered }) => [
                                                styles.dropDownCreatorView,
                                                hovered && styles.dropDownCreatorViewHovered
                                            ]} 
                                            onPress={() => {filterByCampaign(campaign)}}
                                            accessible={true}
                                            aria-label={`Filter by ${campaign.label} campaign`}
                                            role="button"
                                        >
                                            <Image
                                                style={styles.campaignPreviewImage}
                                                source={campaign.imageExists
                                                    ? {uri: 'https://d3p3fw3rutb1if.cloudfront.net/business/photos/' + campaign.value}
                                                    : blueLandscapeIcon
                                                }
                                                defaultSource={blueLandscapeIcon}
                                                resizeMode="cover"
                                            />
                                            <Text style={styles.boldBlueText}>{campaign.label}</Text>
                                        </Pressable>
                                    ))}
                                </View>
                            )}
                        </View>
                        <View>
                            {campaignFilter.label && (
                                <Text style={styles.boldBlueText}>{campaignFilter.label}</Text>
                            )}
                            {!campaignFilter.label && (
                                <Text style={styles.boldBlueText}>All Messages</Text>
                            )}
                        </View>
                        <Pressable 
                            style={({ hovered }) => [
                                styles.plusIcon,
                                hovered && { backgroundColor: '#f3f4f6', transform: [{ scale: 1.1 }] }
                            ]} 
                            onPress={openChatModal}
                            accessible={true}
                            aria-label="Start new message"
                            role="button"
                        >
                            <Image
                                source={plusIcon}
                                style={styles.addCampaignImg}
                            />
                        </Pressable>
                    </View>
                    <View style={styles.channelsView}>
                        {channels.map((creator, index) => (
                            <Pressable 
                                key={`channel-${index}`} 
                                onPress={() => openChat(creator)}
                                style={({ hovered }) => [
                                    index % 2 === 0 ? styles.creatorEvenRow : styles.creatorOddRow,
                                    (selectedUser.channel && selectedUser.channel.url === creator.channel.url) ? styles.selectedMessageRow : {},
                                    hovered && { backgroundColor: creator.channel.unreadMessageCount > 0 ? '#dbeafe' : '#f3f4f6' }
                                ]}
                                accessible={true}
                                aria-label={`Open chat with ${creator.nickname}`}
                                role="button"
                            >
                                <Image
                                    source={{uri: "https://d3p3fw3rutb1if.cloudfront.net/users-preview/" + creator.id}}
                                    defaultSource={defaultProfileIcon}
                                    style={styles.creatorPreviewImage}
                                    onError={() => {
                                        // If the image fails to load, the defaultSource will be used automatically
                                    }}
                                />
                                <View>
                                    <Text style={styles.boldBlueText}>{creator.nickname}</Text>
                                    {creator.channel.lastMessage && (
                                        <Text style={creator.channel.unreadMessageCount > 0 ? styles.unreadMessageText : styles.lastMessageText}>{creator.channel.lastMessage.message}</Text>
                                    )}
                                </View>
                                {creator.channel.unreadMessageCount > 0 && (
                                    <View style={styles.redDotView}/>
                                )}
                            </Pressable>
                        ))}
                    </View>
                </View>
                <View style={styles.chatContainer}>
                    {selectedUser && selectedUser.channel && selectedUser.channel.url && (
                        <SendbirdProvider
                            appId={'960C8598-DEDE-43E0-89FA-45442999623C'}
                            userId={businessSummary.businessId}
                            colorSet={myColorSet}
                        >
                            {/* GroupChannel should be always wrapped inside SendbirdProvider */}
                            <GroupChannel channelUrl={selectedUser.channel.url} />
                        </SendbirdProvider>
                    )}
                </View>
            </View>
            <Modal
                isOpen={newMessageModal}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                className={"invite-modal"}
                style={styles.modal}
            >
                <View style={styles.newMessageView}>
                    <View style={styles.newMessageHeader}>
                        <Text style={styles.modalTitle}>New Message</Text>
                        <View style={styles.campaignSelectContainer}>
                            <Select
                                options={activeCampaigns}
                                values={[defaultCampaign]}
                                style={styles.campaignSelect}
                                itemRenderer={({ item, methods }) => (
                                    <Pressable 
                                        style={({ hovered }) => [
                                            styles.dropDownCreatorView,
                                            hovered && styles.dropDownCreatorViewHovered
                                        ]} 
                                        onPress={() => {methods.addItem(item); setDefaultCampaign(item);}}
                                        accessible={true}
                                        aria-label={`Select ${item.label} campaign`}
                                        role="button"
                                    >
                                        <Image
                                            style={styles.campaignPreviewImage}
                                            source={item.imageExists
                                                ? {uri: 'https://d3p3fw3rutb1if.cloudfront.net/business/photos/' + item.value}
                                                : blueLandscapeIcon
                                            }
                                            defaultSource={blueLandscapeIcon}
                                            resizeMode="cover"
                                        />
                                        <Text style={styles.boldBlueText}>{item.label}</Text>
                                    </Pressable>
                                )}
                                onChange={(value) => filterActiveCreators(value)}
                            />
                        </View>
                    </View>
                    {activeCreators.map(creator => (
                        <Pressable 
                            key={creator.id} 
                            onPress={() => {createNewMessage(creator)}}
                            style={({ hovered }) => [
                                styles.creatorRow,
                                hovered && styles.creatorRowHovered
                            ]}
                            accessible={true}
                            aria-label={`Message ${creator.first_name} ${creator.last_name}`}
                            role="button"
                        >
                            <View style={styles.creatorRowContent}>
                                <Image
                                    source={{uri: "https://d3p3fw3rutb1if.cloudfront.net/users-preview/" + creator.id}}
                                    defaultSource={defaultProfileIcon}
                                    style={styles.creatorPreviewImage}
                                    onError={() => {
                                        // If the image fails to load, the defaultSource will be used automatically
                                    }}
                                />
                                <View style={styles.creatorInfo}>
                                    <Text style={styles.creatorName}>{creator.first_name} {creator.last_name}</Text>
                                </View>
                                <View style={styles.flexEndView}>
                                    {creator.messaged && (
                                        <View style={styles.messageBadge}>
                                            <Text style={styles.messageBadgeText}>Continue Message</Text>
                                        </View>
                                    )}
                                    {!creator.messaged && (
                                        <Text style={styles.creatorDate}>Added {creator.added_date}</Text>
                                    )}
                                </View>
                            </View>
                        </Pressable>
                    ))}
                </View>
            </Modal>
        </View>
    );
}

const styles = StyleSheet.create({
    // Main Layout
    messageContainer: {
        height: '100vh',
        backgroundColor: '#f8f9ff',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    contentContainer: {
        flexDirection: 'row',
        flex: 1,
        gap: 0,
        height: 0, // Force flex child to respect parent constraints
        overflow: 'hidden',
    },
    
    // Left Sidebar (Chat Users)
    chatUsersContainer: {
        width: '30%',
        backgroundColor: '#f8f9ff',
        borderRightWidth: 1,
        borderRightColor: '#e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        overflow: 'hidden',
    },
    messagesHeader: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 20,
        paddingVertical: 15,
        backgroundColor: 'white',
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
        borderRadius: 12,
        margin: 16,
        marginBottom: 8,
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        zIndex: 10,
        flexShrink: 0, // Prevent header from shrinking
    },
    channelsView: {
        backgroundColor: 'white',
        flex: 1,
        borderRadius: 12,
        marginHorizontal: 16,
        marginBottom: 16,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'auto',
        height: 0, // Force scrolling when content overflows
        minHeight: 0, // Allow flex child to shrink below content size
        // Custom scrollbar styling for webkit browsers
        scrollbarWidth: 'thin',
        scrollbarColor: '#e5e7eb transparent'
    },
    
    // Channel List Items
    creatorEvenRow: {
        backgroundColor: 'white',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        borderBottomWidth: 1,
        borderBottomColor: '#f3f4f6',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        position: 'relative',
        minHeight: 80, // Ensure consistent row height
        flexShrink: 0, // Prevent compression when scrolling
    },
    creatorOddRow: {
        backgroundColor: '#fafbfc',
        flexDirection: 'row',
        alignItems: 'center',
        padding: 16,
        borderBottomWidth: 1,
        borderBottomColor: '#f3f4f6',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        position: 'relative',
        minHeight: 80, // Ensure consistent row height
        flexShrink: 0, // Prevent compression when scrolling
    },
    selectedMessageRow: {
        backgroundColor: '#e6f2ff',
        borderLeftWidth: 4,
        borderLeftColor: '#396de0',
    },
    creatorPreviewImage: {
        width: 48,
        height: 48,
        borderRadius: 24,
        marginRight: 12,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        backgroundColor: '#f3f4f6', // Light background for default images
    },
    messagePreviewImage: {
        width: 48,
        height: 48,
        borderRadius: 24,
        marginRight: 12,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        backgroundColor: '#f3f4f6', // Light background for default images
    },
    
    // Right Side (Chat Container)
    chatContainer: {
        flex: 1,
        backgroundColor: 'white',
        borderRadius: 12,
        margin: 16,
        marginLeft: 8,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        // height: '95%',
        // display: 'flex',
        // flexDirection: 'column',
    },
    
    // Typography
    boldBlueText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        fontWeight: '600',
        color: '#396de0',
        marginBottom: 2,
    },
    lastMessageText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        color: '#737373',
        marginTop: 4,
        lineHeight: 16,
        maxWidth: 200,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    unreadMessageText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        color: '#374151',
        fontWeight: '600',
        marginTop: 4,
        lineHeight: 16,
        maxWidth: 200,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    boldGreyText: {
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 18,
        fontWeight: '600',
        color: '#374151',
    },
    lightGreyText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        color: '#6b7280',
    },
    
    // Icons and Buttons
    addCampaignImg: {
        width: 24,
        height: 24,
    },
    plusIcon: {
        padding: 4,
        borderRadius: 6,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
    },
    
    // Modal Styles
    modal: {
        overlay: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(57, 109, 224, .8)',
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1000,
        },
        content: {
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            margin: 'auto',
            maxHeight: '80vh',
            width: '600px',
            maxWidth: '90vw',
            background: 'none',
            border: 'none',
            borderRadius: 0,
            padding: 0,
            overflow: 'visible',
        }
    },
    newMessageView: {
        maxHeight: '70vh',
        overflow: 'auto',
        backgroundColor: 'white',
        borderRadius: 12,
        padding: 24,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    },
    modalTitle: {
        fontFamily: "'forma-djr-display', sans-serif",
        fontSize: 24,
        fontWeight: 'bold',
        color: '#396de0',
        marginBottom: 20,
        textAlign: 'center',
    },
    newMessageHeader: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 20,
        zIndex: 1000,
    },
    campaignSelectContainer: {
        flex: 1,
        alignItems: 'flex-end',
    },
    campaignSelect: {
        width: 250,
    },
    
    // Modal Content
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 12,
        marginHorizontal: -12,
        borderRadius: 8,
        transition: 'all 0.2s ease',
    },
    creatorRow: {
        borderRadius: 8,
        marginBottom: 8,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
    },
    creatorRowHovered: {
        backgroundColor: '#f3f4f6',
        transform: [{ scale: 1.02 }],
    },
    creatorRowContent: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 12,
    },
    creatorInfo: {
        flex: 1,
    },
    creatorName: {
        fontFamily: "'lato', sans-serif",
        fontSize: 16,
        fontWeight: '600',
        color: '#374151',
    },
    creatorDate: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        color: '#6b7280',
    },
    messageBadge: {
        backgroundColor: '#e6f2ff',
        paddingHorizontal: 12,
        paddingVertical: 4,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#b8cbf5',
    },
    messageBadgeText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 12,
        fontWeight: '600',
        color: '#396de0',
    },
    
    // Dropdown Styles
    dropDownCreatorView: {
        flexDirection: 'row',
        alignItems: 'center',
        padding: 8,
        borderRadius: 8,
        transition: 'all 0.2s ease',
        cursor: 'pointer',
    },
    dropDownCreatorViewHovered: {
        backgroundColor: '#f3f4f6',
    },
    campaignPreviewImage: {
        width: 40,
        height: 40,
        borderRadius: 8,
        marginRight: 12,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        backgroundColor: '#f3f4f6',
    },
    
    // Campaign Filter
    campaignFilterView: {
        position: 'absolute',
        maxHeight: '60vh', // Responsive height based on viewport
        backgroundColor: 'white',
        overflow: 'auto',
        zIndex: 20,
        width: 280,
        top: 40,
        left: 0,
        borderRadius: 12,
        borderWidth: 1,
        borderColor: '#e5e7eb',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        padding: 8,
    },
    centeredView: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 12,
        borderBottomWidth: 1,
        borderBottomColor: '#e5e7eb',
        marginBottom: 8,
    },
    clearFilterButton: {
        paddingHorizontal: 16,
        paddingVertical: 8,
        borderRadius: 6,
        transition: 'all 0.2s ease',
    },
    clearFilterButtonHovered: {
        backgroundColor: '#f3f4f6',
    },
    clearFilterText: {
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        fontWeight: '600',
        color: '#396de0',
    },
    
    // Utilities
    flexEndView: {
        alignItems: 'flex-end',
        flex: 1,
        paddingRight: 12,
    },
    redDotView: {
        width: 8,
        height: 8,
        backgroundColor: '#dc2626',
        borderRadius: 4,
        position: 'absolute',
        right: 16,
        top: '50%',
        marginTop: -4,
    },
    
    // Legacy styles - keeping for SendBird compatibility
    notesInput: {
        padding: 12,
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
        borderWidth: 1,
        borderColor: '#d1d5db',
        borderRadius: 8,
        backgroundColor: '#f3f4f6',
        color: '#374151',
        marginRight: 20,
        transition: 'border-color 0.2s ease',
        outlineStyle: 'none',
    },
    messageView: {
        flex: 1,
        flexDirection: 'column-reverse',
        paddingBottom: 20,
    },
    sentMessage: {
        color: 'white',
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
    },
    sentMessageView: {
        backgroundColor: '#396de0',
        padding: 12,
        alignSelf: 'flex-end',
        marginTop: 8,
        marginRight: 16,
        marginLeft: 60,
        borderRadius: 18,
        borderBottomRightRadius: 4,
        maxWidth: '70%',
    },
    receivedMessage: {
        color: '#374151',
        fontFamily: "'lato', sans-serif",
        fontSize: 14,
    },
    receivedMessageView: {
        backgroundColor: '#f3f4f6',
        padding: 12,
        alignSelf: 'flex-start',
        marginTop: 8,
        marginLeft: 16,
        marginRight: 60,
        borderRadius: 18,
        borderBottomLeftRadius: 4,
        maxWidth: '70%',
    },
    receivedRow: {
        flexDirection: 'row',
        alignItems: 'flex-end',
        flex: 1,
    },
    sendIcon: {
        width: 20,
        height: 20,
    },
    sendTouchable: {
        position: 'absolute',
        right: 30,
        bottom: 10,
    },
});

export default Message
